import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import appReducer from "../store/appSlice";
import userReducer from "../store/userSlice";
import groupReducer from "../store/groupSlice";
import collectionReducer from "../store/collectionSlice";

const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    group: groupReducer,
    collection: collectionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
